import {
  AircraftType,
  CrewMemberDto,
  FlightStatus,
  FlightType,
  LocationDto,
  TimestampType,
  WaypointRole,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { AircraftEntity } from 'src/store/aircraft/aircraft.model';
import { BaseEntity } from 'src/store/base/base.model';
import { humanize } from 'src/util/text';

export enum FlightOutcome {
  Unknon = 'Unknown',
  Underway = 'Underway',
  Completed = 'Completed',
  Aborted = 'Aborted',
}
export function flightOutcomeDisplay(outcome: FlightOutcome): string {
  return humanize(outcome);
}

export interface FlightSummaryDto {
  id: string | null;
  dispatchId: string | null;
  programId: string | null;
  company: CompanyDto;
  transportBase: BaseEntity;
  aircraft: AircraftEntity;
  aircraftType: AircraftType;
  dateOfService: string | null;
  flightStatus: FlightStatus;
  flightType?: FlightType;
  flightOutcome: FlightOutcome;
  abortReason: string | null;
  crewMembers: CrewMemberDto[];
  pointsOfInterest: FlightSummaryWaypointDto;
  times: TimestampDto[];
  isDeleted: boolean;
  hasLaunched: boolean;
}

export interface CompanyDto {
  id: string;
  name: string | null;
}

export interface FlightSummaryWaypointDto extends LocationDto {
  role: WaypointRole;
}

export interface TimestampDto {
  time: string;
  type: TimestampType;
  description: string;
}
